import React, { Component } from "react";
import _ from "lodash";
import Button from "../base-components/button"
import { sendAPIRequest } from "shared/utils/requests";

class ScoringInterview extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  static getDerivedStateFromProps(props, state) {

    return null;
  }

  componentDidMount = () => {
  }

  componentDidUpdate(_, prevState) {
    
  }

  componentWillUnmount() {
  }

  render() {
    return (
      <div className="onboarding-rejection-container">
        <div className="onboarding-biglabel onboarding-rejection-body">
          <div>Good day.</div>

          <div>As you have completed the technical test, I would now like to invite you to a video interview.  Please plot your schedule on the link below:</div>

          <div><a href="https://calendly.com/mitch-qaworld/30min" className="onboarding-rejection-links" target="_blank" rel="noopener noreferrer">Chat with Mitch</a></div>

          <div>If possible, kindly schedule an interview tomorrow.</div>

          <div>Kindly be advised that our meeting room will be the <a href="https://whereby.com/qaworld_interview" className="onboarding-rejection-links" target="_blank" rel="noopener noreferrer">Interview Room</a>. As you will need to set up your camera and mic, please be in the room at least 10 to 15 minutes before your actual interview. Or set it up a day prior to the scheduled interview.  </div>

          <div>Note: Only weekday schedules are available for now. Weekend schedules are available upon request.</div>
        </div>
      </div>
    );  }

}

export default ScoringInterview;
